import { render, staticRenderFns } from "./CommissionChart.vue?vue&type=template&id=0386e23a&"
import script from "./CommissionChart.vue?vue&type=script&lang=js&"
export * from "./CommissionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports